import React from 'react'
import Profile from "../Images/Cm_profile.jpg"
import "../styles/about.css";
import { FaRegHandPointRight } from "react-icons/fa"
import svg from "../Images/beeline.svg";
import Html from "../Images/skills-svg/html.svg";
import Acessibility from "../Images/skills-svg/accessibility.svg";
import Css from "../Images/skills-svg/css.svg";
import FIrebase from "../Images/skills-svg/firebase.svg";
import Github from "../Images/skills-svg/github.svg";
import Javascript from "../Images/skills-svg/javascript.svg";
import Reactsvg from "../Images/skills-svg/react.svg";
import Sass from "../Images/skills-svg/sass.svg";


const About = () => {
    return (
        <header className='section'>
 <section className='section-center about-container'>
 <div className='about-box-1'>
    <div className='about-image'>
        <img src={svg} alt='profile-svg' className='about-svg'/>
    </div>
        <img src={Profile} alt="profile-image" className='profile-img'/>
    </div>
    <div className='about-box-2'>
        <h2>I'm Chaitali</h2>
        <span className="about-me-text highlighted-text">
            Hello, I am a Front-End Developer based in Canada.🌇
          </span>
          <div className="content-about-list">
        <ul className="content-about">
          <li className="content-about-me">
          <FaRegHandPointRight /> I am passionate about clean UI and intuitive user experiences.
            Experienced in building responsive web applications using modern
            technologies such as HTML, CSS, Sass, JavaScript and React.
          </li>
          <li className="content-about-me">
            <FaRegHandPointRight /> I keep accessibility in mind while writing
            clean, reusable code. I thrive in collaborative environments and enjoy creative 
               <span className="highlighted-text">
            problem-solving, contributing to positive work
            experience through communication and time management.</span>
          </li>
          <li className="content-about-me">
            <FaRegHandPointRight /> I have developed strong interpersonal skills
            and am able to quickly adapt to changes in a fast-paced environment.
          </li>
          <li className="content-about-me">
            <FaRegHandPointRight />
            As mentioned above, I'm specialized in{" "}
            <span className="highlighted-text">
              HTML/CSS and JavaScript on the frontend,
            </span>{" "}
            but I'm pretty comfortable with ReactJS, NodeJS, MongoDB, Firebase,
            Wordpress, PHP, etc. For more details about my completed my <a href="/Projects">Projects</a> and
             <a href='https://github.com/chaitali72'> Github</a> profiles.
          </li>
        </ul>
      
       
      </div>
    </div>
  
 </section>
 <section className='section-center skills'>
 <div className="section-title">
         <h3>My Toolkit</h3>
         <div className="underline"></div>
        </div>
        <ul className='skills-toolkit'>
            <li ><img src={Html} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={Css} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={Javascript} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={Reactsvg} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={Github} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={Acessibility} alt='skills-svg' className='svg-img'/></li>
            <li ><img src={FIrebase} alt='skills-svg' className='svg-img'/></li> 
            <li ><img src={Sass} alt='skills-svg' className='svg-img'/></li>
           
        </ul>
 </section>
        </header>
    )
}
export default About
